// --------------------------------------------------------------------------
// imageGallery.js
// --------------------------------------------------------------------------
// Uses fancybox to create lightbox image gallery
// --------------------------------------------------------------------------

RN.imageGallery = function() {

  'use strict';

  function init() {
    byBehaviour('image-gallery').fancybox({
        mouseWheel: false,
        padding: 0,
        maxWidth: 1024
    });
  }

  return {
    init: init
  };

}();